export const YEARLY_INCOME_LIMIT = 10000000;

export const HUD_ANIMAL_POLICY_URL = 'https://www.hud.gov/helping-americans/fair-housing-act-overview';

export const ASSISTANCE_ANIMAL_DISCLAIMER_TEXT =
  'Assistance animals, including those trained to assist with a disability, don’t need to be listed.';
